const newsletterLocalPreviewHosts = ['127.0.0.1', 'localhost', '0.0.0.0'];
const newsletterDiscountPendingKey = 'newsletter-discount-pending';

function getNewsletterDiscountRedirect(form) {
  const returnTo = form?.querySelector('input[name="return_to"]');
  if (!returnTo) return null;

  try {
    return new URL(returnTo.value, window.location.origin).searchParams.get('redirect');
  }
  catch (error) {
    return null;
  }
}

function getNewsletterDiscountCode(form) {
  const returnTo = form?.querySelector('input[name="return_to"]');
  if (!returnTo) return null;

  try {
    const discountPath = new URL(returnTo.value, window.location.origin).pathname;
    return decodeURIComponent(discountPath.split('/discount/')[1] || '');
  }
  catch (error) {
    return null;
  }
}

function setNewsletterDiscountPending(form) {
  const discountCode = getNewsletterDiscountCode(form);
  if (!discountCode) return;

  try {
    sessionStorage.setItem(newsletterDiscountPendingKey, discountCode);
  }
  catch (error) {}
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('form.newsletter-form')) return;

  const redirect = getNewsletterDiscountRedirect(form);
  if (!redirect || !form.checkValidity()) return;

  setNewsletterDiscountPending(form);

  if (newsletterLocalPreviewHosts.includes(window.location.hostname)) {
    event.preventDefault();
    event.stopImmediatePropagation();

    window.location.href = redirect;
  }
}, true);

if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return [...this.querySelectorAll('.alert')].some((alert) => !alert.closest('[data-newsletter-discount-success]'));
      }

      get autoShow() {
        return this.getAttribute('data-auto-show') === 'true';
      }

      get discountSuccessParam() {
        return this.getAttribute('data-discount-success-param');
      }

      get discountSuccessValue() {
        return this.getAttribute('data-discount-success-value') || 'applied';
      }

      get discountCode() {
        return this.getAttribute('data-discount-code') || '';
      }

      get discountApplied() {
        if (!this.discountSuccessParam) return false;

        const params = new URLSearchParams(window.location.search);
        const value = params.get(this.discountSuccessParam);
        return value === this.discountSuccessValue || value === `${this.discountSuccessValue}#NewsletterModal`;
      }

      get discountCookieApplied() {
        const discountCode = this.discountCode;
        if (!discountCode) return false;

        const appliedCode = this.getCookie('discount_code');
        if (!appliedCode) return false;

        return decodeURIComponent(appliedCode) === discountCode;
      }

      get discountPending() {
        try {
          return sessionStorage.getItem(newsletterDiscountPendingKey) === this.discountCode;
        }
        catch (error) {
          return false;
        }
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (this.discountApplied || (this.discountPending && this.discountCookieApplied)) {
          this.showDiscountSuccess();
          this.load(0);
          return;
        }
        
        if (window.location.hash === '#NewsletterModal') {
          this.load(0);
          return;
        }

        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }

        if (this.testMode || (this.autoShow && !this.getCookie(this.cookieName))) {
          this.load(this.delay);
        }
      }

      showDiscountSuccess() {
        this.classList.add('discount-applied');
        this.setCookie(this.cookieName, this.expiry);
        this.clearDiscountPending();

        const success = this.querySelector('[data-newsletter-discount-success]');
        if (success) {
          success.hidden = false;
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }

      clearDiscountPending() {
        try {
          sessionStorage.removeItem(newsletterDiscountPendingKey);
        }
        catch (error) {}
      }
    }
  );
}
